import { Routes, Route } from "react-router-dom";
import Dashboard from "../dashboard/superadmin/Dashboard";
import { ActiveAndExpiredProducts } from "../dashboard/superadmin/ActiveAndExpiredProducts";
import { StoresList } from "../dashboard/superadmin/StoresList";
import LoginPage from "../login/Login.page";
import { AuthenticatedRoute } from "./AuthenticatedRoute";
import ForgotPassword from "../login/ForgotPassword";
import ResetPassword from "../login/ResetPassword";
import PageNotFound from "../common/PageNotFound";
import { CreateCorporation } from "../Corporation/CreateCorporation";
import { ManageCorporation } from "../Corporation/ManageCorporation";
import { ExploreCorporation } from "../Corporation/ExploreCorporation";
import { CreateOrganization } from "../Organization/CreateOrganization";
import { ManageOrganization } from "../Organization/ManageOrganization";
import { CreateUser } from "../User/CreateUser";
import { ManageUser } from "../User/ManageUser";
import { CreateSuperUser } from "../SuperUser/CreateSuperUser";
import { ManageSuperUser } from "../SuperUser/ManageSuperUser";
import { CreateProduct } from "../Product/CreateProduct";
import { ManageProduct } from "../Product/ManageProduct";
import { SearchOrder } from "../Order/SearchOrder";
import { ViewUsers } from "../View/Users";
import { Configuration } from "../Configuration/Configuration";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/dashboard"
        element={<AuthenticatedRoute component={Dashboard} />}
      />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      <Route
        path="/create/corporation"
        element={<AuthenticatedRoute component={CreateCorporation} />}
      />
      <Route
        path="/manage/corporation"
        element={<AuthenticatedRoute component={ManageCorporation} />}
      />
      <Route
        path="/edit/corporation"
        element={<AuthenticatedRoute component={CreateCorporation} />}
      />
      <Route
        path="/manage/corporation/explore"
        element={<AuthenticatedRoute component={ExploreCorporation} />}
      />
      <Route
        path="/create/organization"
        element={<AuthenticatedRoute component={CreateOrganization} />}
      />
      <Route
        path="/manage/organization"
        element={<AuthenticatedRoute component={ManageOrganization} />}
      />
      <Route
        path="/edit/organization"
        element={<AuthenticatedRoute component={CreateOrganization} />}
      />
      <Route
        path="/create/user"
        element={<AuthenticatedRoute component={CreateUser} />}
      />
      <Route
        path="/manage/user"
        element={<AuthenticatedRoute component={ManageUser} />}
      />
      <Route
        path="/edit/user"
        element={<AuthenticatedRoute component={CreateUser} />}
      />
      <Route
        path="/create/super-user"
        element={<AuthenticatedRoute component={CreateSuperUser} />}
      />
      <Route
        path="/manage/super-user"
        element={<AuthenticatedRoute component={ManageSuperUser} />}
      />
      <Route
        path="/edit/super-user"
        element={<AuthenticatedRoute component={CreateSuperUser} />}
      />
      <Route
        path="/create/product"
        element={<AuthenticatedRoute component={CreateProduct} />}
      />
      <Route
        path="/manage/product"
        element={<AuthenticatedRoute component={ManageProduct} />}
      />
      <Route
        path="/edit/product"
        element={<AuthenticatedRoute component={CreateProduct} />}
      />
      <Route
        path="/search/order"
        element={<AuthenticatedRoute component={SearchOrder} />}
      />
      <Route
        path="/view/users"
        element={<AuthenticatedRoute component={ViewUsers} />}
      />
      <Route
        path="/configuration"
        element={<AuthenticatedRoute component={Configuration} />}
      />
      <Route
        path="/dashboard/products/active"
        element={<AuthenticatedRoute component={ActiveAndExpiredProducts} />}
      />
      <Route
        path="/dashboard/products/expired"
        element={<AuthenticatedRoute component={ActiveAndExpiredProducts} />}
      />
      <Route
        path="/dashboard/stores"
        element={<AuthenticatedRoute component={StoresList} />}
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default MainRoutes;
